"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AbstractSettingsManager = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/settings/AbstractSettingsManager"));

var _ComponentSettings = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/settings/ComponentSettings"));

var _Console = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/Console"));

var _UrlUtility = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/util/UrlUtility"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * Manages settings for services.
 */
var ServiceSettings = /*#__PURE__*/function (_AbstractSettingsMana) {
  _inherits(ServiceSettings, _AbstractSettingsMana);

  var _super = _createSuper(ServiceSettings);

  function ServiceSettings() {
    _classCallCheck(this, ServiceSettings);

    return _super.apply(this, arguments);
  }

  _createClass(ServiceSettings, null, [{
    key: "getDefaultSettings",

    /**
     * Returns the default settings.
     *
     * @abstract
     * @returns {object} Default settings as an object.
     */
    value: function getDefaultSettings() {
      return {
        consumer: null,
        contract: null,
        applicationName: null,
        applicationTranslationName: null,
        dexfApplicationId: null,
        uiPlatform: _UrlUtility.default.getAppInfo().uiPlatform,
        storeId: null,
        vpcAcceptableConfigurationSources: [],
        vpcConfigurationSource: null,
        allowRetailItemCommSpecificFields: false,
        forceProductionDexfVpc: false,
        forceProductionChinaApi: false,
        debug: false,
        disableArticleQueue: false,
        retailItemEfficiencyClasses: ['00025', '00033', '00037', '00032', '00035'],
        commonLocalization: '/addon-app/localizations/common/latest/{country}/{language}/',
        appLocalization: '/addon-app/localizations/{applicationName}/latest/{country}/{language}/',
        commonMasterLocalization: '/addon-app/localizations/common/latest/global/',
        appMasterLocalization: '/addon-app/localizations/{applicationName}/latest/global/',
        irwBagName: null
      };
    }
    /**
     * Returns the settings manager name.
     *
     * @override
     * @returns {string} Settings manager name.
     */

  }, {
    key: "uiPlatform",

    /**
     * Returns the ui platform.
     *
     * @returns {string} UI platform;.
     */
    get: function get() {
      return this.settings.get('uiPlatform') || null;
    }
    /**
     * Sets the UI platform.
     *
     * @param {string} uiPlatform UI platform;.
     */
    ,
    set: function set(uiPlatform) {
      this.settings.set('uiPlatform', uiPlatform);
      _ComponentSettings.default.uiPlatform = uiPlatform;
    }
    /**
     * Returns the application name.
     *
     * @returns {string} Application name.
     */

  }, {
    key: "applicationName",
    get: function get() {
      return this.settings.get('applicationName') || null;
    }
    /**
     * Sets the application name.
     *
     * @param {string} applicationName Application name.
     */
    ,
    set: function set(applicationName) {
      this.settings.set('applicationName', applicationName.toLowerCase());
    }
    /**
     * Returns the store id.
     *
     * @deprecated
     * @returns {string} Store ID.
     */

  }, {
    key: "storeId",
    get: function get() {
      return this.settings.get('storeId') || null;
    }
    /**
     * Sets the store id.
     *
     * @deprecated
     * @param {string} storeId Store ID.
     */
    ,
    set: function set(storeId) {
      if (storeId) {
        _Console.default.warn('Setting "ServiceSettings.storeId" is deprecated. It should be sent to the StoreAvailabilityServiceFacade.getAvailability() method instead.');
      }

      this.settings.set('storeId', storeId);
    }
    /**
     * Returns the VPC acceptable configuration sources.
     *
     * @deprecated
     * @returns {string[]} VPC acceptable configuration sources.
     */

  }, {
    key: "vpcAcceptableConfigurationSources",
    get: function get() {
      return this.settings.get('vpcAcceptableConfigurationSources') || null;
    }
    /**
     * Sets the VPC acceptable configuration sources.
     *
     * @deprecated
     * @param {string[]} vpcAcceptableConfigurationSources VPC acceptable configuration sources.
     */
    ,
    set: function set(vpcAcceptableConfigurationSources) {
      if (vpcAcceptableConfigurationSources) {
        _Console.default.warn('Setting "ServiceSettings.vpcAcceptableConfigurationSources" is deprecated. It can optionally be sent to VpcServiceFacade.getConfiguration() method instead.');
      }

      this.settings.set('vpcAcceptableConfigurationSources', vpcAcceptableConfigurationSources);
    }
    /**
     * Returns the VPC configuration source.
     *
     * @deprecated
     * @returns {string[]} VPC configuration source.
     */

  }, {
    key: "vpcConfigurationSource",
    get: function get() {
      return this.settings.get('vpcConfigurationSource') || null;
    }
    /**
     * Sets the VPC configuration source.
     *
     * @deprecated
     * @param {string[]} vpcConfigurationSource VPC configuration source.
     */
    ,
    set: function set(vpcConfigurationSource) {
      if (vpcConfigurationSource) {
        _Console.default.warn('Setting "ServiceSettings.vpcConfigurationSource" is deprecated. It does not need to be defined as it will use "applicationName" instead.');
      }

      this.settings.set('vpcConfigurationSource', vpcConfigurationSource);
    }
    /**
     * Returns the allow RetailItemCommSpecificFields state.
     *
     * @deprecated
     * @returns {boolean} Allow RetailItemCommSpecificFields.
     */

  }, {
    key: "allowRetailItemCommSpecificFields",
    get: function get() {
      return this.settings.get('allowRetailItemCommSpecificFields') || null;
    }
    /**
     * Sets the allow RetailItemCommSpecificFields state.
     *
     * @deprecated
     * @param {boolean} allowRetailItemCommSpecificFields Allow RetailItemCommSpecificFields.
     */
    ,
    set: function set(allowRetailItemCommSpecificFields) {
      if (allowRetailItemCommSpecificFields) {
        _Console.default.warn('Setting "ServiceSettings.allowRetailItemCommSpecificFields" is deprecated. All fields are returned by default now.');
      }

      this.settings.set('allowRetailItemCommSpecificFields', allowRetailItemCommSpecificFields);
    }
  }, {
    key: "settingsName",
    get: function get() {
      return 'ServiceSettings';
    }
  }]);

  return ServiceSettings;
}(_AbstractSettingsManager.default);

exports.default = ServiceSettings;
ServiceSettings.setupProperties();
_ComponentSettings.default.uiPlatform = ServiceSettings.uiPlatform;